import "core-js/modules/es.number.constructor";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

var AppTab = /*#__PURE__*/function (_Vue) {
  _inherits(AppTab, _Vue);

  var _super = _createSuper(AppTab);

  function AppTab() {
    var _this;

    _classCallCheck(this, AppTab);

    _this = _super.apply(this, arguments);
    _this.tab = null;
    _this.activeTab = 0;
    return _this;
  }

  _createClass(AppTab, [{
    key: "changeTab",
    value: function changeTab(index) {
      this.activeTab = index;
      this.emitTab();
    }
  }, {
    key: "emitTab",
    value: function emitTab() {
      return this.activeTab;
    }
  }, {
    key: "changeValue",
    value: function changeValue(val) {
      this.activeTab = val;
    }
  }]);

  return AppTab;
}(Vue);

__decorate([Prop({
  type: Number,
  default: 0
})], AppTab.prototype, "value", void 0);

__decorate([Prop({
  type: Array
})], AppTab.prototype, "items", void 0);

__decorate([Emit('change')], AppTab.prototype, "emitTab", null);

__decorate([Watch('value', {
  immediate: true
})], AppTab.prototype, "changeValue", null);

AppTab = __decorate([Component({})], AppTab);
export default AppTab;